/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Record_Toggle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Record Toggle" |
*
* @param {Player_Record_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_record_toggle_aria_label = /** @type {((inputs?: Player_Record_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Record_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer l'Enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufnahme umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar grabación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制切换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("記録切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड टॉगल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar gravação")
	return /** @type {LocalizedString} */ ("Record Toggle")
});